import { BitmapLayer } from "@deck.gl/layers";
import { useMemo } from "react";
import { useSelector } from "react-redux";

import { appDispatch } from "../../App";
import { getWaterdepthLayerOpen } from "../../state/layerCalculationMenu";
import { getWaterDepthImages, waterDepthImageLoaded } from "../../state/waterdepth";

const useWaterDepthImageLayer = () => {
  const waterDepthImages = useSelector(getWaterDepthImages);
  const waterdepthLayerOpen = useSelector(getWaterdepthLayerOpen);
  const renderImageUrl = useMemo(() => {
    if (!waterDepthImages || !waterDepthImages.length) return "";
    const newWaterDepthImage = waterDepthImages[waterDepthImages.length - 1];
    const img = document.createElement("img");
    img.src = newWaterDepthImage.objectUrl;
    img.onload = () => {
      appDispatch(waterDepthImageLoaded(newWaterDepthImage));
    };
    return img;
  }, [waterDepthImages]);

  if (!waterDepthImages || !waterDepthImages.length) return [];
  const bounds = waterDepthImages[waterDepthImages.length - 1].bounds;

  return new BitmapLayer({
    id: "water-depth-image-layer",
    bounds: [bounds.getWest(), bounds.getSouth(), bounds.getEast(), bounds.getNorth()],
    image: renderImageUrl,
    visible: waterdepthLayerOpen,
  });
};
export default useWaterDepthImageLayer;
